<app-page-heading [key]="'carrier-import.verification-tool.title'" [helper]="true" [helperContent]="helper"></app-page-heading>

<section class="container-fluid" *ngIf="!verificationResult || verificationResult.missingCarriersColumns.length > 0">
    <app-file-drop [(files)]="files" [disabled]="doing" (onChange)="changeFile()"></app-file-drop>

    <div class="btn-container">
        <button class="btn btn-primary btn-xl m-l-sm btn-import" (click)="verifyData()" [disabled]="isVerifyEnabled()">
            <i class="fa fa-check-circle"></i>&nbsp;
            <span [i18n]="[{target: 'innerHTML', key: 'carrier-import.verification-tool.verify'}]"></span>
        </button>
    </div>
</section>

<section class="container-fluid" *ngIf="verificationResult && verificationResult.missingCarriersColumns.length === 0">
    <div class="header-result">
        <div class="file-container">
            <span class="title" [i18n]="'carrier-import.verification-tool.file'"></span>
            <div class="file" (click)="emptyFile()">
                <i class="fa fa-file-excel-o"></i>
                <span class="file-name">{{files[0].name}}</span>
            </div>
        </div>
        <div class="result-container">
            <span class="result" [i18n]="[{target: 'innerHTML', key: 'carrier-import.verification-tool.result.total', params: { okCarriers: verificationResult.totalNumberOfCarriersInSuccess, totalCarriers: verificationResult.totalNumberOfCarriers }}]"></span>
            <span class="summary" [i18n]="[{target: 'innerHTML', key: 'carrier-import.verification-tool.result.summary', params: { percent: (verificationResult.totalNumberOfCarriersInSuccess * 100 / verificationResult.totalNumberOfCarriers).toFixed(0) }}]"></span>
        </div>
        <button class="btn btn-primary btn-xl m-l-sm btn-download" [disabled]="hasNoOkCarriers()" (click)="downloadOkCarriers()">
            <i class="fa fa-download"></i>&nbsp;
            <span [i18n]="'carrier-import.verification-tool.result.download-ok'"></span>
        </button>
    </div>
    <div class="result-body">
        <span class="title" [i18n]="'carrier-import.verification-tool.result.title'"></span>

        <div class="result-tabs">
            <div class="carrier-ok" [class.active]="resultTab === 'OK'" (click)="resultTab = 'OK'">
                <span [i18n]="'carrier-import.verification-tool.result.ok'"></span>
            </div>
            <div class="carrier-ko" [class.active]="resultTab === 'KO'" (click)="resultTab = 'KO'">
                <span [i18n]="'carrier-import.verification-tool.result.ko'"></span>
            </div>
        </div>

        <div class="result-content">
            <table class="table table-bordered table-striped text-left">
                <thead>
                    <tr class="header-line">
                        <th class="name-header" [i18n]="'carrier-import.verification-tool.result.table.carrier-name'"></th>
                        <th class="code-header" [i18n]="'carrier-import.verification-tool.result.table.carrier-code'"></th>
                        <th class="managers-header" [i18n]="'carrier-import.verification-tool.result.table.carrier-manager'"></th>
                        <th class="error-header" *ngIf="resultTab === 'KO'" [i18n]="'carrier-import.verification-tool.result.table.errors'"></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let carrierRow of verificationResult.carriersRows">
                        <tr *ngIf="(resultTab === 'OK' && !carrierRow.failed) || (resultTab === 'KO' && carrierRow.failed)" [class.clickable-tr]="resultTab === 'KO'" [class.showing-error]="showErrors(carrierRow)" (click)="toggleErrorsView(carrierRow, $event)">
                            <td class="carrier-name">{{carrierRow.rowValue.name}}</td>
                            <td class="carrier-code">{{carrierRow.rowValue.code}}</td>
                            <td class="carrier-managers">{{getCarrierManagerListFromCarrierRow(carrierRow)}}</td>
                            <td class="error-header" *ngIf="resultTab === 'KO' && carrierRow.failed">
                                <div class="show-error" (click)="toggleErrorsView(carrierRow, $event)">
                                    <i class="fa" [ngClass]="{ 'fa-angle-down': !showErrors(carrierRow), 'fa-angle-up': showErrors(carrierRow) }"></i>
                                </div>
                            </td>
                        </tr>
                        <tr class="errors-line" *ngIf="showErrors(carrierRow)">
                            <td colspan="4">
                                <!-- Name errors -->
                                <ng-container *ngIf="shouldShowNameError(carrierRow)">
                                    <app-collapsible [opened]="false" [arrowElementRef]="arrow">
                                        <div collapsibleHeader class="flex-row space-between" (click)="arrow.triggerToggle()">
                                            <label [i18n]="'carrier-import.verification-tool.errors.name'"></label>
                                            <app-collapsible-arrow #arrow [size]="'sm'"></app-collapsible-arrow>
                                        </div>
                                        <div collapsibleBody class="flex-row space-between">
                                            <table class="table table-bordered table-striped text-left">
                                                <thead>
                                                <tr>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.error-type'"></th>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.identifier'"></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr *ngFor="let error of getCarrierNameErrors(carrierRow)">
                                                    <td [i18n]="[{target: 'innerHTML', key: 'carrier-import.verification-tool.errors.types.'+error.type, params: {field: getCapitalizedErrorField(error)}}]"></td>
                                                    <td><span *ngIf="error.type !== 'MISSING'">{{getErrorIdentifier(error)}}</span></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </app-collapsible>
                                </ng-container>

                                <!-- Code errors -->
                                <ng-container *ngIf="shouldShowCodeError(carrierRow)">
                                    <app-collapsible [opened]="false" [arrowElementRef]="arrow">
                                        <div collapsibleHeader class="flex-row space-between" (click)="arrow.triggerToggle()">
                                            <label [i18n]="'carrier-import.verification-tool.errors.code'"></label>
                                            <app-collapsible-arrow #arrow [size]="'sm'"></app-collapsible-arrow>
                                        </div>
                                        <div collapsibleBody class="flex-row space-between">
                                            <table class="table table-bordered table-striped text-left">
                                                <thead>
                                                <tr>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.error-type'"></th>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.identifier'"></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr *ngFor="let error of getCarrierCodeErrors(carrierRow)">
                                                    <td [i18n]="[{target: 'innerHTML', key: 'carrier-import.verification-tool.errors.types.'+error.type, params: {field: getCapitalizedErrorField(error)}}]"></td>
                                                    <td><span *ngIf="error.type !== 'MISSING'">{{getErrorIdentifier(error)}}</span></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </app-collapsible>
                                </ng-container>

                                <!-- Region errors -->
                                <ng-container *ngIf="shouldShowRegionError(carrierRow)">
                                    <app-collapsible [opened]="false" [arrowElementRef]="arrow">
                                        <div collapsibleHeader class="flex-row space-between" (click)="arrow.triggerToggle()">
                                            <label [i18n]="'carrier-import.verification-tool.errors.region'"></label>
                                            <app-collapsible-arrow #arrow [size]="'sm'"></app-collapsible-arrow>
                                        </div>
                                        <div collapsibleBody class="flex-row space-between">
                                            <table class="table table-bordered table-striped text-left">
                                                <thead>
                                                <tr>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.error-type'"></th>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.value'"></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr *ngFor="let error of getCarrierRegionErrors(carrierRow)">
                                                    <td [i18n]="[{target: 'innerHTML', key: 'carrier-import.verification-tool.errors.types.'+error.type, params: {field: getCapitalizedErrorField(error)}}]"></td>
                                                    <td><span *ngIf="error.type !== 'MISSING'">{{carrierRow.rowValue.region}}</span></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </app-collapsible>
                                </ng-container>

                                <!-- Contact errors -->
                                <ng-container *ngIf="shouldShowContactError(carrierRow)">
                                    <app-collapsible [opened]="false" [arrowElementRef]="arrow">
                                        <div collapsibleHeader class="flex-row space-between" (click)="arrow.triggerToggle()">
                                            <label [i18n]="'carrier-import.verification-tool.errors.contact'"></label>
                                            <app-collapsible-arrow #arrow [size]="'sm'"></app-collapsible-arrow>
                                        </div>
                                        <div collapsibleBody class="flex-row space-between">
                                            <table class="table table-bordered table-striped text-left">
                                                <thead>
                                                <tr>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.error-type'"></th>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.value'"></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr *ngFor="let error of getCarrierContactErrors(carrierRow)">
                                                    <td [i18n]="[{target: 'innerHTML', key: 'carrier-import.verification-tool.errors.types.'+error.type, params: {field: getCapitalizedErrorField(error)}}]"></td>
                                                    <td>{{error.fieldValue}}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </app-collapsible>
                                </ng-container>

                                <!-- Language errors -->
                                <ng-container *ngIf="shouldShowLanguageError(carrierRow)">
                                    <app-collapsible [opened]="false" [arrowElementRef]="arrow">
                                        <div collapsibleHeader class="flex-row space-between" (click)="arrow.triggerToggle()">
                                            <label [i18n]="'carrier-import.verification-tool.errors.language'"></label>
                                            <app-collapsible-arrow #arrow [size]="'sm'"></app-collapsible-arrow>
                                        </div>
                                        <div collapsibleBody class="flex-row space-between">
                                            <table class="table table-bordered table-striped text-left">
                                                <thead>
                                                <tr>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.error-type'"></th>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.value'"></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr *ngFor="let error of getCarrierLanguageErrors(carrierRow)">
                                                    <td [i18n]="[{target: 'innerHTML', key: 'carrier-import.verification-tool.errors.types.'+error.type, params: {field: getCapitalizedErrorField(error)}}]"></td>
                                                    <td><span *ngIf="error.type !== 'MISSING'">{{carrierRow.rowValue.preferredLanguageCode}}</span></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </app-collapsible>
                                </ng-container>

                                <!-- Manager missing errors -->
                                <ng-container *ngIf="shouldShowManagerMissingError(carrierRow)">
                                    <app-collapsible [opened]="false" [arrowElementRef]="arrow">
                                        <div collapsibleHeader class="flex-row space-between" (click)="arrow.triggerToggle()">
                                            <label [i18n]="'carrier-import.verification-tool.errors.manager-missing'"></label>
                                            <app-collapsible-arrow #arrow [size]="'sm'"></app-collapsible-arrow>
                                        </div>
                                        <div collapsibleBody class="flex-row space-between">
                                        <span class="missing-manager">
                                            <i class="fa fa-exclamation-triangle"></i>
                                            <span [i18n]="'carrier-import.verification-tool.errors.manager-missing-message'"></span>
                                        </span>
                                        </div>
                                    </app-collapsible>
                                </ng-container>

                                <!-- Manager errors -->
                                <ng-container *ngIf="shouldShowManagerError(carrierRow)">
                                    <app-collapsible [opened]="false" [arrowElementRef]="arrow">
                                        <div collapsibleHeader class="flex-row space-between" (click)="arrow.triggerToggle()">
                                            <label [i18n]="'carrier-import.verification-tool.errors.manager'"></label>
                                            <app-collapsible-arrow #arrow [size]="'sm'"></app-collapsible-arrow>
                                        </div>
                                        <div collapsibleBody class="flex-row space-between">
                                            <table class="table table-bordered table-striped text-left">
                                                <thead>
                                                <tr>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.carrier-manager'"></th>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.error-type'"></th>
                                                    <th [i18n]="'carrier-import.verification-tool.result.table.identifier'"></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <ng-container *ngFor="let managerRow of carrierRow.carrierManagers">
                                                    <tr *ngFor="let error of getCarrierManagerErrors(managerRow)">
                                                        <td>{{managerRow.rowValue.emailAddress}}</td>
                                                        <td [i18n]="[{target: 'innerHTML', key: 'carrier-import.verification-tool.errors.types.'+error.type, params: {field: getCapitalizedErrorField(error)}}]"></td>
                                                        <td><span *ngIf="error.type !== 'INVALID'">{{getErrorIdentifier(error)}}</span></td>
                                                    </tr>
                                                </ng-container>
                                                </tbody>
                                            </table>
                                        </div>
                                    </app-collapsible>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</section>

<section class="container-fluid" *ngIf="verificationResult && (verificationResult.reason === VerificationErrorReason.COULD_NOT_EXTRACT_HEADER_COLUMNS || verificationResult.reason === VerificationErrorReason.INVALID_HEADER_COLUMNS) &&verificationResult.missingCarriersColumns.length > 0">
    <div class="template-error">
        <span class="error-title" [i18n]="'carrier-import.verification-tool.errors.template'"></span>
        <div class="template-helper">
            <span [i18n]="'carrier-import.verification-tool.errors.template-carrier'"></span>
            <span [i18n]="'carrier-import.verification-tool.errors.template-carrier-manager'"></span>
        </div>
    </div>
</section>

<ng-template #helper>
    <div [i18n]="'carrier-import.verification-tool.helper'"></div>
</ng-template>
